import makeApiCall from "./axiosIndex";

const sequenceApis = {
    createSequence: (data: any): Promise<any> => makeApiCall({
        method: "post",
        url: "/buyer/createSequence",
        data
    }),
    
    fetchSequence: (level: any,id:any): Promise<any> => makeApiCall({
        method: "get",
        url: "/buyer/fetchSequence",
        params:{level, projectId : id}
    }),

    fetchSequenceById: (id: any): Promise<any> => makeApiCall({
        method: "get",
        url: "/buyer/fetchSequenceById",
        params: { deptId:id }
    }),
    updateSequenceById: (id: any, data: any): Promise<any> => makeApiCall({
        method: "put",
        url: "/buyer/updateSequenceById",
        params: { id },
        data
    }),
    updateSequenceStatusById: (id: any): Promise<any> => makeApiCall({
        method: "put",
        url: "/buyer/updateSequenceStatusById",
        params: { id },
    }),
    deleteSequenceById: (id: any): Promise<any> => makeApiCall({
        method: "delete",
        url: "/buyer/deleteSequenceById",
        params: { id }
    })
};
export default sequenceApis
